import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { DateComponentComponent } from "./date-component/date-component.component";
import { LoadingComponent } from "./loading/loading.component";

@NgModule({
    declarations: [
      LoadingComponent,
      DateComponentComponent
    ],
    exports:[
      LoadingComponent, 
      DateComponentComponent
    ],
    imports: [
      CommonModule,
      IonicModule
    ]
  })

export class ComponentsModule { 


}